// extracted by mini-css-extract-plugin
export default {"root":"nCXE7NL3","icon":"CkfxRMRW","iconOnly":"yxXUuCCN","s":"q96v23DV","m":"smyM5Xx8","orange":"_Q95mLpw","dark":"v8JxmqZe","green":"wlydRiie","red":"F_ekOwwf","gray":"jLX_FBcy"};